<ion-header>
  <ion-toolbar>
    <ion-title>
      {{'gym-chat-page.gym-chat' | translate}}
      <ion-icon name="chatbubbles-outline"></ion-icon>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="allMessages">
  <ion-refresher (ionRefresh)="onRefresh()" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-fab horizontal="end" slot="fixed" vertical="bottom">
    <ion-fab-button *ngIf="visibleMessages" color="primary" (click)="addMessage()">
      <ion-icon name="pencil"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <message *ngFor="let message of visibleMessages" [author]="message.author" [text]="message.text"
           [date]="message.date" [showDeleteButton]="message.author === authService.getCurrentUsername()"
           (onDelete)="deleteMessage(message.messageId)"></message>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="listMessages($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{'gym-chat-page.load-messages' | translate}}">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <h2 *ngIf="allMessages.length===0">{{'gym-chat-page.no-messages-yet' | translate}}</h2>
</ion-content>
<loader *ngIf="!allMessages"></loader>
